/**
 * @fileoverview Data model to hold a complete launch submission request.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

import {EnterpriseConfiguration, EnterpriseConfigurationJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';

export class SubmitRequest {
  /**
   * @param {{
   *   configuration: EnterpriseConfiguration,
   * }} params
   */
  constructor(params) {
    /** @type {EnterpriseConfiguration} */
    this.configuration = params.configuration;
  }

  /**
   * @return {!SubmitRequestJson}
   */
  toJSON() {
    return {
      'configuration': this.configuration.toJSON(),
    };
  }
}

/**
 * @dict
 * @typedef {{
 *   configuration: EnterpriseConfigurationJson,
 * }}
 */
export let SubmitRequestJson;
